import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { NAV_LINKS } from "@/lib/constants";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `text-xs font-semibold uppercase tracking-wide px-3 py-2 rounded-md transition-colors ${
      isActive ? "text-[#8CE63C]" : "text-[#9EABA0] hover:text-[#f4f7f4]"
    }`;

  return (
    <nav className="sticky top-0 z-40 backdrop-blur-md bg-[#0a0d0a]/85 border-b border-[#232f25]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" onClick={() => setOpen(false)}>
          <Brand size="md" />
        </Link>

        <div className="hidden lg:flex items-center gap-0.5">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={linkClass}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-[#f4f7f4] p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#232f25] bg-[#0a0d0a] px-4 py-3 space-y-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-3 py-3 rounded-md text-sm font-semibold uppercase tracking-wide ${
                  isActive || location.pathname === l.to
                    ? "bg-[#132717] text-[#8CE63C]"
                    : "text-[#9EABA0] hover:bg-[#111712]"
                }`
              }
              data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};
